export const rootURL = "https://subscribers.ruthwrites.online";
export const checkoutURL = "https://subscribers.ruthwrites.online";
// export const rootURL = "http://localhost:3000";
// export const checkoutURL = "http://localhost:3001";
export const StripeKey = 'pk_live_xpbxA8zRulnQTQbMYLHnNRBT';
